import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { LayoutUtilsService } from '../../../../../../core/_base/crud';
import { Subscription } from 'rxjs';
import { AppState } from '../../../../../../core/reducers';
import { InternalAccessEditComponent } from '../internal-access-edit/internal-access-edit..component';
import { QrveyService } from '../../../../../../core/lists/_services/qrvey.service';
import { UsersAccessListComponent } from '../../users-access-list/users-access-list.component';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'kt-internal-access-list',
  templateUrl: './internal-access-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InternalAccessListComponent implements OnInit, OnDestroy {
  dataSource: any;
  displayedColumns = ['teams', 'pages', 'actions'];
  private subscriptions: Subscription[] = [];
  private appId = null;

  constructor(
    public dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private layoutUtilsService: LayoutUtilsService,
    private store: Store<AppState>,
    private qrveyService: QrveyService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params.app_id) {
        this.appId = params.app_id;
        this.loadInternalAccessList();
      }
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  loadInternalAccessList() {
    this.subscriptions.push(
      this.qrveyService.getTeamsByApplication(this.appId).subscribe((res) => {
        this.dataSource = res.data?.filter((e) => e.type === 'USER');
        this.cdr.detectChanges();
      }),
    );
  }

  deleteInternalAccess(_item) {
    const _title = 'Delete Internal Access';
    const _description = 'Are you sure you want to delete Internal Access?';
    const _waitDescription = 'Deleting...';

    const dialogRef = this.layoutUtilsService.deleteElement(_title, _description, _waitDescription);
    dialogRef.afterClosed().subscribe((res) => {
      if (!res) {
        return;
      }
      this.subscriptions.push(
        this.qrveyService.removeInternalAccess(this.appId, _item.id, _item.type).subscribe(() => {
          this.loadInternalAccessList();
          this.cdr.detectChanges();
        }),
      );
    });
  }

  editInternalAccess(_item) {
    const dialogRef = this.dialog.open(InternalAccessEditComponent, {
      data: { mode: 'UPDATE', _item },
    });
    dialogRef.afterClosed().subscribe(() => {
      this.loadInternalAccessList();
    });
  }

  createInternalAccess() {
    const dialogRef = this.dialog.open(InternalAccessEditComponent, {
      data: { mode: 'CREATE' },
    });
    dialogRef.afterClosed().subscribe(() => {
      this.loadInternalAccessList();
    });
  }

  usersView() {
    const dialogRef = this.dialog.open(UsersAccessListComponent, {
      data: { type: 'USER', ids: this.dataSource?.map((e) => e.team_id), entityId: '' },
    });
    dialogRef.afterClosed().subscribe();
  }
}
